<template>
    <div class="full-box" id="full-box">
        <div class="sub-full-box">
            <div v-if="!noPermission">
                <slot/>
            </div>
            <div v-else>
                <h3 class="error-text">Permission Denied</h3>
                <p>You don't have permission to access this page, please try other pages or contact your administrator.</p>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "FullFullBox",
    data(){
        return{
            noPermission: false,
        }
    },
    props: {
        pageID: '',
        otherPer: '',
    },
    watch: {
        'pageID': {
            async handler(getData) {
                await this.startToCheck()
            },
        },
    },
    methods: {
        async startToCheck(){
            if(this.$store.state.isAuthenticated === false){
                this.$router.push('/login')
            }else{
                this.noPermission = false
                if(this.pageID && this.pageID !== 0){
                    // 1. Check Page access
                    let pagePermission = await this.$permissionCheck(this.pageID)
                    if(pagePermission.status === 0){
                        this.noPermission = true
                    }else{
                        this.noPermission = false
                        this.$emit('permissionData', pagePermission.details)
                        if(this.otherPer && Array.isArray(this.otherPer)){
                            let result = []
                            for(let i of this.otherPer){
                                let functionPermission = await this.$permissionCheck(i)
                                result.push(functionPermission)
                            }
                            this.$emit('otherPermission', result)
                        }
                    }
                }
            }
        }
    },
    mounted() {
        this.startToCheck()
    }
}
</script>

<style scoped>

.full-box{
    background-color: white;
    border: solid #c5c5c5 3px;
    border-radius: 10px;
    margin: 1%;
}

.sub-full-box{
    margin: auto;
    width: 95%;
}

@media screen and (min-width : 0px) and (max-width : 1023px){
    .sub-full-box{
        width: 99%;
    }
}

</style>
